import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/layout/Layout';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import BlogPage from './pages/BlogPage';
import ArticlePage from './pages/ArticlePage';
import ContactPage from './pages/ContactPage';
import ServicePage from './pages/ServicePage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminPosts from './pages/admin/AdminPosts';
import PostEditor from './pages/admin/PostEditor';
import AdminCategories from './pages/admin/AdminCategories';
import AdminMedia from './pages/admin/AdminMedia';
import AdminLeads from './pages/admin/AdminLeads';
import AdminCalculatorLeads from './pages/admin/AdminCalculatorLeads';
import AdminPesquisaPlantao from './pages/admin/AdminPesquisaPlantao';
import PesquisaPlantaoPage from './pages/PesquisaPlantaoPage';
import CalculadoraPlantao from './pages/CalculadoraPlantao';
import AdminSiteImages from './pages/admin/AdminSiteImages';
import AdminServices from './pages/admin/AdminServices';
import AdminSiteContent from './pages/admin/AdminSiteContent';
import AdminSettings from './pages/admin/AdminSettings';
import './App.css';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

// Public Admin Route - redirects to dashboard if already logged in
const PublicAdminRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-100">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/admin" replace />;
  }

  return children;
};

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/sobre" element={<Layout><AboutPage /></Layout>} />
          <Route path="/servicos" element={<Layout><ServicesPage /></Layout>} />
          <Route path="/blog" element={<Layout><BlogPage /></Layout>} />
          <Route path="/blog/:slug" element={<Layout><ArticlePage /></Layout>} />
          <Route path="/servico/:slug" element={<Layout><ServicePage /></Layout>} />
          <Route path="/contato" element={<Layout><ContactPage /></Layout>} />
          <Route path="/calculadora-plantao" element={<Layout><CalculadoraPlantao /></Layout>} />
          <Route path="/cipe" element={<Layout><CalculadoraPlantao /></Layout>} />
          <Route path="/cipe.html" element={<Layout><CalculadoraPlantao /></Layout>} />
          <Route path="/pesquisa-plantao" element={<PesquisaPlantaoPage />} />
          <Route path="/plantao" element={<PesquisaPlantaoPage />} />
          <Route path="/plantao.html" element={<PesquisaPlantaoPage />} />

          {/* Admin Routes */}
          <Route
            path="/admin/login"
            element={
              <PublicAdminRoute>
                <AdminLogin />
              </PublicAdminRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="posts" element={<AdminPosts />} />
            <Route path="posts/new" element={<PostEditor />} />
            <Route path="posts/:id" element={<PostEditor />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="site-images" element={<AdminSiteImages />} />
            <Route path="site-content" element={<AdminSiteContent />} />
            <Route path="services" element={<AdminServices />} />
            <Route path="media" element={<AdminMedia />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="calculator-leads" element={<AdminCalculatorLeads />} />
            <Route path="pesquisa-plantao" element={<AdminPesquisaPlantao />} />
            <Route path="settings" element={<AdminSettings />} />
          </Route>

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
